import type {ComponentType, SVGProps} from "react";
import {ArrowUturnLeftIcon} from "@heroicons/react/24/outline";

const OUTLINE_CLASSES =
    "rounded-md border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700";

interface Props {
    icon?: ComponentType<SVGProps<SVGSVGElement>>;
    label: string;
    undoLabel: string;
    testId: string;
    className?: string;
    onUndoClick?: () => void;
}

export function UndoableTag({icon: Icon, label, undoLabel, testId, className, onUndoClick}: Props) {
    return (
        <span
            className={`inline-flex items-center gap-1 whitespace-nowrap ${className ?? OUTLINE_CLASSES}`}
            data-testid={testId}
        >
            {Icon && <Icon className="size-3.5 text-gray-400" />}
            <span>{label}</span>
            {onUndoClick && (
                <button
                    type="button"
                    onPointerDown={(event) => event.stopPropagation()}
                    onMouseDown={(event) => event.stopPropagation()}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onUndoClick();
                    }}
                    className="inline-flex size-[18px] items-center justify-center rounded-full text-current opacity-50 transition hover:bg-black/10 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                    aria-label={undoLabel}
                    title={undoLabel}
                >
                    <ArrowUturnLeftIcon className="size-3.5" />
                </button>
            )}
        </span>
    );
}
